import { CheckCircle2 } from "lucide-react";
import { Link } from "react-router";

export function LegalAndCertificationsPage() {
  return (
    <div className="min-h-screen bg-[#F6F2EB]">
      <section className="py-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Legal Entity & Certifications</h1>
          <p className="text-muted-foreground">Information about our corporate structure and compliance standards.</p>
        </div>
      </section>

      <section className="pb-12">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          
          <div className="mb-12 bg-white rounded-3xl p-8 border border-[#131312]/10 shadow-sm">
            <h2 className="text-2xl font-bold mb-6 text-[#131312]">Business Information</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-muted-foreground">
              <div>
                <p className="font-semibold text-[#131312] mb-1">Commercial Brand</p>
                <p>Colour Club Printers</p>
              </div>
              <div>
                <p className="font-semibold text-[#131312] mb-1">Legal Entity & Supplier</p>
                <p>Paper Printing Services</p>
              </div>
              <div>
                <p className="font-semibold text-[#131312] mb-1">FSC Certificate Holder</p>
                <p>Paper Printing Services</p>
              </div>
              <div>
                <p className="font-semibold text-[#131312] mb-1">Invoice and Bank Beneficiary</p>
                <p>Paper Printing Services</p>
              </div>
              <div>
                <p className="font-semibold text-[#131312] mb-1">Sales Enquiries</p>
                <p><a href="mailto:info@colourclubprinters.com" className="hover:underline">info@colourclubprinters.com</a></p>
              </div>
              <div>
                <p className="font-semibold text-[#131312] mb-1">Legal & Compliance</p>
                <p><a href="mailto:info@paperprintingservices.com" className="hover:underline">info@paperprintingservices.com</a></p>
              </div>
            </div>
            
            <div className="mt-8 pt-6 border-t border-[#131312]/10">
              <p className="text-[#131312]/80 leading-relaxed">
                <strong>Colour Club Printers</strong> is a trading brand operated by <strong>Paper Printing Services</strong>. 
                Both entities share the same facility, management, address, and contact details in Faisalabad, Pakistan. 
                Paper Printing Services is the legal contracting, invoicing, and certified manufacturing entity.
              </p>
            </div>
          </div>

          <div className="mb-12 bg-white rounded-3xl p-8 border border-[#131312]/10 shadow-sm">
            <h2 className="text-2xl font-bold mb-6 text-[#131312]">Certifications</h2>
            
            <div className="space-y-8">
              <div className="flex flex-col md:flex-row gap-6 items-start">
                <div className="w-24 shrink-0 bg-[#F6F2EB] p-4 rounded-xl flex items-center justify-center">
                  <img src="/FSC.png" alt="FSC Logo" className="w-full h-auto" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">FSC Certification</h3>
                  <p className="text-muted-foreground mb-4">
                    FSC Chain of Custody certification is held by Paper Printing Services, the legal entity operating the Colour Club Printers brand.
                  </p>
                  <ul className="space-y-2">
                    <li className="flex items-center gap-2 text-sm">
                      <CheckCircle2 className="size-4 text-green-600" /> Responsible forest management
                    </li>
                    <li className="flex items-center gap-2 text-sm">
                      <CheckCircle2 className="size-4 text-green-600" /> Chain of custody verified
                    </li>
                  </ul>
                </div>
              </div>
              
              <div className="flex flex-col md:flex-row gap-6 items-start">
                <div className="w-24 shrink-0 bg-[#F6F2EB] p-4 rounded-xl flex items-center justify-center">
                  <img src="/iso9001.webp" alt="ISO 9001 Logo" className="w-full h-auto" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">ISO 9001</h3>
                  <p className="text-muted-foreground mb-4">
                    Our quality management systems are certified to ISO 9001 standards under Paper Printing Services.
                  </p>
                </div>
              </div>

              <div className="flex flex-col md:flex-row gap-6 items-start">
                <div className="w-24 shrink-0 bg-[#F6F2EB] p-4 rounded-xl flex items-center justify-center">
                  <img src="/sedex.png" alt="Sedex Logo" className="w-full h-auto" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">SEDEX Member</h3>
                  <p className="text-muted-foreground mb-4">
                    We are committed to ethical and responsible business practices throughout our supply chain.
                  </p>
                </div>
              </div>
            </div>
            
          </div>
          
        </div>
      </section>
    </div>
  );
}
